export const NAME = "additionalInfo";
